import { mapGetters, mapState } from 'vuex';
import plantsClient from '@/core/services/plants';
import { Vue, Options } from 'vue-class-component';
import {
  EPDeviceDTO,
  EntrancePlantDetailDTO,
  GateDTO,
} from '@/../client-generator/generated-clients/plants';
import { SET_APP_LOADING } from '@/core/store/action-types';
import DeviceItem from './DeviceItem/DeviceItem.vue';
import { getDeviceIconFromType } from '../../../../core/utils/EntrancePlant/entrance-plant.utils';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';
import DialogAddEditGate from './DialogAddEditGate/DialogAddEditGate.vue';

@Options({
  name: 'EntrancePlantGate',
  emits: ['update-list'],
  components: {
    DeviceItem,
    DialogAddEditGate,
    DialogConfirmDelete,
  },
  computed: {
    ...mapState(['currentEntrancePlant', 'adminView']),
  },
})
export default class EntrancePlantGate extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  adminView!: boolean;
  isVisibleDeleteGateConfirm = false;
  isVisibleDialogConfigureGate = false;
  getGateIconFromType = getDeviceIconFromType;


  get gateDevices() {
    if (this.currentGate && this.hasDevices) {
      const devices = (this.currentGate.devices ?? []).sort(
        (a, b) => a.type! - b.type!
      );
      return devices;
    }
    return [];
  }

  get hasDevices() {
    return !!this.currentGate?.devices?.length;
  }

  get currentGate(): GateDTO | null {
    return (
      this.currentEntrancePlant?.gates?.find(
        (x) => x.gateId?.toString() === this.$route.params.gateId
      ) ?? null
    );
  }

  get gateId() {
    return this.$route.params.gateId as string;
  }

  get backLink() {
    return {
      name: 'page-entranceplant-dashboard',
      params: this.$route.params,
    };
  }

  mounted() {
    if (this.$route.query.refresh) {
      this.$emit('update-list');
      this.$router.push({
        name: 'page-entranceplant-gate',
        params: this.$route.params,
      });
    }
  }

  async toggleConfigureGateDialog() {
    this.isVisibleDialogConfigureGate = !this.isVisibleDialogConfigureGate;
  }

  toggleDeleteGateConfirm() {
    this.isVisibleDeleteGateConfirm = !this.isVisibleDeleteGateConfirm;
  }

  async deleteGate() {
    if (
      !this.currentEntrancePlant ||
      !this.currentEntrancePlant.desktopId ||
      !this.currentGate ||
      !this.currentGate.gateId
    )
      return;
    try {
      this.$store.dispatch(SET_APP_LOADING, true);
      await plantsClient.gateDELETE(
        this.currentEntrancePlant.desktopId,
        this.currentGate.gateId
      );

      this.$store.dispatch(SET_APP_LOADING, false);
      this.$emit('update-list');
      this.$toast.add({
        severity: 'success',
        summary: this.$t('entrancePlant.gateDeletedSuccess'),
        closable: false,
        life: 3000,
      });
      this.$router.push({ name: 'page-entranceplant-dashboard' });
    } catch (error) {
      switch (error.status) {
        case 423:
          this.$router.push({
            name: 'page-plants-hub',
          });
          break;
      }
      console.log(error);
      this.$toast.add({
        severity: 'error',
        summary: this.$t('general.operationError'),
        closable: true,
        life: 3000,
      });
      this.$store.dispatch(SET_APP_LOADING, false);
    }
  }

  handleUpdateList() {
    this.$emit('update-list');
  }
}
